import configurationService from "./ConfigurationService";

function getUrl(name, ...args) {
  const urls = {
    identityServiceServer: `${configurationService.identityService}`,
    userManagementServiceServer: `${configurationService.userManagementService}`,
    organizationApi: `${configurationService.organizationApi}`,

    deployment: `${configurationService.dashboardService}/api/deployment`,
    organizationMap: `${configurationService.dashboardService}/api/organizations`,
    organizationNameById: `${configurationService.dashboardService}/api/organizations/{1}`,
    userInfoById: `${configurationService.eviewServiceInternalApi}/v1.0/admin/getusersinfo`,
    projectSummaries: `${configurationService.dashboardService}/api/project/{1}/summary`,
    projectSize: `${configurationService.dashboardService}/api/project/{1}/{2}/size`,
    ai: `${configurationService.dashboardService}/api/ai/eviewservice`,
    projectstore: `${configurationService.dashboardService}/api/ai/projectstore`,
    projectstorepublish: `${configurationService.dashboardService}/api/ai/projectstorepublish`,
    hpservice: `${configurationService.dashboardService}/api/ai/hpservice`,
    hpworker: `${configurationService.dashboardService}/api/ai/hpworker`,
  };

  let url = urls[name];
  if (!url) {
    throw new Error(`Url: ${name} not found`);
  }

  const count = args.length;
  let i = 0;
  for (i = 0; i < count; i++) {
    const arg = args[i];
    const replace = "{" + (i + 1) + "}";
    const foundIdx = url.indexOf(replace);
    if (foundIdx < 0) {
      throw new Error(`too many parameters: ${arg}`);
    }
    url = url.replace(replace, arg);
  }

  const replace = "{" + (i + 1) + "}";
  const foundIdx = url.indexOf(replace);
  if (foundIdx >= 0) {
    throw new Error(`url parameter: ${replace} not set`);
  }

  return url;
}

export default getUrl;
